export default __webpack_public_path__ + "static/media/plus.0a4ef9e8.svg";